<template>
    <div class="years_popup" v-if="isShowYearsPopup">
        <div class="in">
            <div class="btn_close" @click="closeYearsPopup"></div>
            <div class="number">
                <div class="item" v-for="(item, index) in 3" :key="index" 
                :class="{active: yearPageActiveIndex == index}">{{index + 1}}</div>
            </div>
            <div class="page_container">
                <div class="page page1" v-if="yearPageActiveIndex == 0">
                    <p class="p1">{{$t('yearsText[0]')}}</p>
                    <p class="p2"><b>{{$t('yearsText[1]')}}</b><br v-if="schoolName == 'high-school-suzhou'"/>{{$t('yearsText[2]')}}</p>
                    <p class="p3">{{$t('yearsText[3]')}}</p>
                    <div class="years">
                        <div class="item" 
                        v-for="(item, index) in years" :key="index" 
                        @click="chooseYear(index)"
                        v-if="schoolName == 'singapore' ? index < 3 : true"
                        :class="{[yearsType[index]]: !isHighSchool}">
                            <img :src="item.thumbnail" alt="" class="cover"/>
                            <div class="text_wrap">
                                <p class="text1">{{item.name}}</p>
                                <p class="text2">{{item.desc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page page2" v-if="yearPageActiveIndex != 0" :class="`color${yearsActiveIndex}`">
                    <div class="top_video">
                        <img :src="years[yearsActiveIndex].image" alt=""/>
                        <!-- <video src="" poster=""></video> -->
                        <div class="text_wrap">
                            <div class="text1">{{years[yearsActiveIndex].name}}</div>
                            <div class="text2">{{years[yearsActiveIndex].desc}}</div>
                        </div>
                    </div>
                    <div class="back" v-if="yearPageActiveIndex == 1" @click="back"><span>{{$t('yearsText[4]')}}</span></div>
                    <div class="back" v-if="yearPageActiveIndex == 2" @click="back"><span>{{$t('yearsText[8]')}}</span></div>
                    <template v-if="yearPageActiveIndex == 1">
                        <div class="title">{{$t('yearsText[5]')}}</div>
                        <div class="group">
                            <template v-if="isHighSchool">
                                <template v-for="(item, index) in years[yearsActiveIndex].group">
                                    <div class="tit">{{item.name}}</div>
                                    <template v-for="(_item, _index) in item.list">
                                        <div class="item"
                                        @click="groupItemTap(index, _index)">
                                            <div class="checkbox" 
                                            :class="{default: _item.is_default, active: _item.isChecked}"></div>
                                            <div class="text">{{_item.name}}</div>
                                        </div>
                                    </template>
                                </template>
                            </template>
                            <template v-else>
                                <div class="item" 
                                v-for="(item, index) in years[yearsActiveIndex].group" 
                                :key="index"
                                @click="groupItemTap(index)">
                                    <div class="checkbox" 
                                    :class="{default: item.is_default, active: item.isChecked}"></div>
                                    <div class="text">{{item.name}}</div>
                                </div>
                            </template>
                        </div>
                        <div class="btn" @click="confirm">{{$t('yearsText[6]')}}</div>
                        <div class="all" @click="allChecked">{{$t('yearsText[7]')}}</div>
                    </template>
                    <template v-if="yearPageActiveIndex == 2">
                        <div class="title">{{$t('yearsText[9]')}}</div>
                        <template v-if="!isPhone">
                            <div class="checked_item">
                                <swiper ref="checkedItem" 
                                :options="checkedItemOptions"
                                :class="{is_high_school: isHighSchool}">
                                    <template v-if="isHighSchool">
                                        <template v-for="(item, index) in years[yearsActiveIndex].group">
                                            <template v-for="(_item, _index) in item.list">
                                                <swiper-slide :key="_index + '_' + index" v-if="_item.isChecked">
                                                    <div class="tit" v-if="_index == 0">{{item.name}}</div>
                                                    <div class="cover" :style="`background-image: url(${_item.thumbnail});`"></div>
                                                    <div class="text">{{_item.name}}</div>
                                                </swiper-slide>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-for="(item, index) in years[yearsActiveIndex].group">
                                            <swiper-slide :key="index" v-if="item.isChecked">
                                                <div class="cover" :style="`background-image: url(${item.thumbnail});`"></div>
                                                <div class="text">{{item.name}}</div>
                                            </swiper-slide>
                                        </template>
                                    </template>
                                </swiper>
                                <div class="swiper-button-prev" slot="button-prev"></div>
                                <div class="swiper-button-next" slot="button-next"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="checked_item_row">
                                <template v-if="isHighSchool">
                                    <template v-for="(item, index) in years[yearsActiveIndex].group">
                                        <div class="tit">{{item.name}}</div>
                                        <template v-for="(_item, _index) in item.list">
                                            <div class="item" :key="_index + '_' + index" v-if="_item.isChecked">
                                                <div class="cover" :style="`background-image: url(${_item.thumbnail});`"></div>
                                                <div class="text">{{_item.name}}</div>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-for="(item, index) in years[yearsActiveIndex].group">
                                        <div class="item" :key="index" v-if="item.isChecked">
                                            <div class="cover" :style="`background-image: url(${item.thumbnail});`"></div>
                                            <div class="text">{{item.name}}</div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </template>
                        <div class="btn type2" @click="toTour">{{$t('yearsText[10]')}}</div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import { Swiper, SwiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "yearsPopup",
    data() {
        return {
            isHighSchool: process.env.VUE_APP_IS_HIGH_SCHOOL == '1',
            schoolName: process.env.VUE_APP_NAME,
            checkedItemOptions: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                navigation: {
                    nextEl: '.checked_item .swiper-button-next',
                    prevEl: '.checked_item .swiper-button-prev',
                },
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
            },
            yearsType: ['ducks', 'js', 'ss'],
        };
    },
    computed: {
        ...mapState(['isShowYearsPopup', 'yearPageActiveIndex', 'yearsActiveIndex', 'years', 'isPhone']),
        swiper() {
            return this.$refs.checkedItem.$swiper
        },
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive
    },
    mounted() {},
    watch: {},
    methods: {
        // 选择年龄
        chooseYear(index){
            this.$store.state.yearPageActiveIndex = 1;
            this.$store.state.yearsActiveIndex = index;
            
            // trackEvent
            let gaLabels = ['select-ducks', 'select-js', 'select-ss'];
            // 新加坡有四个
            // if (this.schoolName == 'singapore') { 
            //     gaLabels.push('select-te');
            // }
            this.$trackEvent(gaLabels[index]);
        },
        // 返回上一页
        back(){
            this.$store.state.yearPageActiveIndex--;
        },
        // 单个选中
        groupItemTap(index, index2){
            let group = this.years[this.yearsActiveIndex].group;
            let item = group[index];
            if(this.isHighSchool){
                item = item.list[index2]
            }
            if(item.is_default){
                return false;
            }
            item.isChecked = !item.isChecked;
        },
        // 全选
        allChecked(){
            let group = this.years[this.yearsActiveIndex].group;
            group.forEach(v=>{
                v.isChecked = true;
            })
            this.confirm();
        },
        // 确认选项
        confirm(){
            this.$store.state.yearPageActiveIndex = 2;

            // trackEvent
            let gaLabels = ['ducks-confirm', 'js-confirm', 'ss-confirm'];
            this.$trackEvent(gaLabels[this.yearsActiveIndex]);
        },
        // 关闭
        closeYearsPopup(){
            this.$store.state.isShowYearsPopup = false;
        },
        toTour(){
            this.$store.state.isShowSelect = false;
            let self = this;
            let group = this.years[this.yearsActiveIndex].group;
            let checkedId = []; //选中的id数组
            group.forEach(v=>{
                if(self.isHighSchool){
                    v.list.forEach(vl => {
                        if(vl.isChecked){
                            checkedId.push(vl.id)
                        }
                    })
                }else{
                    if(v.isChecked){
                        checkedId.push(v.id)
                    }
                }
            })
            this.$showLoading();
            this.$store.dispatch('getPanorama', {
                id: checkedId.join(','),
            }).then(()=>{
                self.$hideLoading();
                self.closeYearsPopup();
                // self.$store.state.groupActiveIndex = 0;
                // self.$store.state.panoramaActiveIndex = 0;
                self.$store.state.yearsCheckedIndex = self.yearsActiveIndex;

                // session
                sessionStorage.setItem(`${process.env.VUE_APP_NAME}_group_id`, checkedId.join(','));

                // 链接
                let yearsName = this.years[this.yearsActiveIndex].en_name.replace(/ /g, '-');
                let group = self.$store.state.group[0];
                let groupName = group.en_name.replace(/ /g, '-');
                let panoramaName = '';
                if (group.type == 0) { 
                    // 是全景图组
                    panoramaName = group.panorama[0].en_name.replace(/ /g, '-');
                }
                let link = `${yearsName}_${groupName}`;
                if (panoramaName != '') { 
                    link += `_${panoramaName}`;
                }
                self.$router.push(`/tour/${link}`);
            });
        }
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.years_popup{
    position: fixed;
    top: .8rem;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    .in{
        position: relative;
        width: 5.6rem;
        // &.singapore{
        //     width: 7.4rem;
        // }
        .btn_close{
            width: .4rem;
            height: .4rem;
            border-radius: 50%;
            background: rgba($color: #000000, $alpha: 0.8);
            position: absolute;
            top: 0;
            right: -0.6rem;
            cursor: pointer;
            &::before,
            &::after{
                content: "";
                width: .2rem;
                height: .02rem;
                background: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .number{
            position: absolute;
            top: .2rem;
            left: -0.5rem;
            .item{
                width: .3rem;
                height: .3rem;
                border-radius: 50%;
                background: rgba($color: #fff, $alpha: 0.5);
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: .2rem;
                font-weight: bold;
                position: relative;
                transition: background-color .3s, color .3s;
                &::after{
                    position: absolute;
                    top: 50%;
                    left: 100%;
                    content: "";
                    border-left: .0rem solid rgba($color: #fff, $alpha: 0.5);
                    border-top: .05rem solid transparent;
                    border-bottom: .05rem solid transparent;
                    transform: translate(-20%, -50%);
                    transition: border .3s;
                }
                &.active{
                    background: #fff;
                    color: #c6001c;
                    &::after{
                        border-left: .06rem solid #fff;
                    }
                }
            }
        }
        .page_container{
            $color1: #feb906;
            $color2: #009acc;
            $color3: #c0011a;
            $color4: #0c912f;
            .page{
                background: #fff;
                border-radius: .05rem;
                overflow: hidden;
                &.color0{
                    background: $color1;
                    .btn{
                        color: $color1;
                        &::after{
                            background-image: url('../assets/images/icon_group_btn_arrow_01.png');
                        }
                    }
                }
                &.color1{
                    background: $color2;
                    .btn{
                        color: $color2;
                        &::after{
                            background-image: url('../assets/images/icon_group_btn_arrow_02.png');
                        }
                    }
                }
                &.color2{
                    background: $color3;
                    .btn{
                        color: $color3;
                        &::after{
                            background-image: url('../assets/images/icon_group_btn_arrow_03.png');
                        }
                    }
                }
                &.color3{
                    background: $color4;
                    .btn{
                        color: $color4;
                        &::after{
                            background-image: url('../assets/images/icon_group_btn_arrow_04.png');
                        }
                    }
                }
            }
            .page1{
                padding: .7rem 0;
                text-align: center;
                .p1{
                    font-size: .3rem;
                }
                .p2{
                    font-size: .24rem;
                    margin-bottom: .3rem;
                }
                .p3{
                    font-size: .2rem;
                    margin-bottom: .6rem;
                    word-spacing: 0.1em;
                    padding: 0 .5rem;
                }
                .years{
                    display: flex;
                    justify-content: center;
                    padding: 0 .25rem;
                    .item{
                        flex: 1;
                        text-align: center;
                        cursor: pointer;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        &:nth-of-type(1){
                            color: $color1;
                            .cover{
                                border-color: $color1;
                            }
                        }
                        &:nth-of-type(2){
                            color: $color2;
                            .cover{
                                border-color: $color2;
                            }
                        }
                        &:nth-of-type(3){
                            color: $color3;
                            .cover{
                                border-color: $color3;
                            }
                        }
                        &:nth-of-type(4){
                            color: $color4;
                            .cover{
                                border-color: $color4;
                            }
                        }
                        .cover{
                            border: .06rem solid #000;
                            border-radius: 50%;
                            margin-bottom: .1rem;
                            width: 1.3rem;
                            height: 1.3rem;
                        }
                        .text1{
                            font-weight: bold;
                            font-size: .18rem;
                        }
                        .text2{
                            font-size: .14rem;
                        }
                    }
                }
            }
            .page2{
                color: #fff;
                padding-bottom: .15rem;
                .back{
                    display: flex;
                    align-items: center;
                    font-size: .2rem;
                    font-weight: bold;
                    color: #fff;
                    cursor: pointer;
                    position: absolute;
                    top: .2rem;
                    left: .2rem;
                    z-index: 1;
                    filter: drop-shadow(0 0 .1rem rgba($color: #000, $alpha: .3));
                    span{
                        border-bottom: .02rem solid rgba($color: #fff, $alpha: 1.0);
                        // text-shadow: 0 0 .1rem rgba($color: #000, $alpha: .3);
                    }
                    &::before{
                        content: "";
                        display: block;
                        width: .14rem;
                        height: .24rem;
                        background: url('../assets/images/icon_arrow_back.png') no-repeat 0/100%;
                        margin-right: .06rem;
                        // filter: drop-shadow(0 0 .1rem rgba($color: #000, $alpha: .3));
                    }
                }
                .top_video{
                    width: 100%;
                    height: 3.15rem;
                    position: relative;
                    overflow: hidden;
                    img,
                    video{
                        width: 100%;
                    }
                    .text_wrap{
                        position: absolute;
                        left: .2rem;
                        bottom: .2rem;
                        font-size: .42rem;
                        text-shadow: 0 0 .1rem rgba($color: #000000, $alpha: 0.8);
                        .text1{
                            font-weight: bold;
                        }
                    }
                }
                .title{
                    font-size: .24rem;
                    text-align: center;
                    font-weight: bold;
                    padding: .18rem 0;
                }
                .group{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: flex-start;
                    align-content: flex-start;
                    padding: 0 .3rem;
                    height: 1.3rem;
                    overflow: hidden;
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    .tit{
                        width: 100%;
                        font-size: .16rem;
                        font-weight: bold;
                        margin-bottom: .1rem;
                    }
                    .item{
                        width: calc(50% - .15rem);
                        display: flex;
                        align-items: center;
                        font-size: .14rem;
                        cursor: pointer;
                        line-height: 1;
                        margin-bottom: .1rem;
                        .checkbox{
                            width: .14rem;
                            height: .14rem;
                            border-radius: .02rem;
                            background: #fff;
                            margin-right: .06rem;
                            &::after{
                                content: "";
                                display: none;
                                width: 100%;
                                height: 100%;
                                background: url('../assets/images/icon_checkbox_checked.png') no-repeat 0/100%;
                            }
                            &.default{
                                opacity: 0.5;
                            }
                            &.active{
                                &::after{
                                    display: block;
                                }
                            }
                        }
                        .text{
                            flex: 1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
                .btn{
                    width: 2rem;
                    height: .36rem;
                    font-size: .16rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    background: #fff;
                    border-radius: .04rem;
                    margin: .2rem auto .15rem;
                    cursor: pointer;
                    &::after{
                        content: "";
                        display: block;
                        width: .08rem;
                        height: .16rem;
                        margin-left: .1rem;
                    }
                    &.type2{
                        width: 1.7rem;
                    }
                }
                .all{
                    text-align: center;
                    font-weight: bold;
                    font-size: .16rem;
                    text-decoration: underline;
                    cursor: pointer;
                }
                .checked_item{
                    position: relative;
                    padding: 0 .2rem;
                    .swiper-container{
                        padding-top: .2rem;
                    }
                    .swiper-slide{
                        width: 1.5rem;
                        margin-right: .1rem;
                        &:last-child{
                            margin-right: 0;
                        }
                        .tit{
                            position: absolute;
                            top: 0;
                            left: 0;
                            transform: translate(0, -100%);
                        }
                        .cover{
                            border-radius: .04rem;
                            margin-bottom: .1rem;
                            height: 1rem;
                            background-repeat: no-repeat;
                            background-size: cover;
                        }
                        .text{
                            font-size: .14rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: center;
                        }
                    }
                }
                .swiper-button-prev,
                .swiper-button-next{
                    width: .20rem;
                    height: .30rem;
                    top: .55rem;
                    margin-top: 0;
                    background: no-repeat center/.15rem;
                    &::after{
                        display: none;
                    }
                }
                .swiper-button-prev{
                    left: 0;
                    background-image: url('../assets/images/icon_checked_item_arrow_prev.png');
                }
                .swiper-button-next{
                    right: 0;
                    background-image: url('../assets/images/icon_checked_item_arrow_next.png');
                }
            }
        }
    }
    @media only screen and (max-width: 640px) {
        top: 1.2rem;
        .in{
            width: 100%;
            height: 100%;
            // &.singapore{
            //     width: 100%;
            // }
            .btn_close{
                right: 0;
                top: 0;
                background: none;
                width: .8rem;
                height: .8rem;
                &::before,
                &::after{
                    background: #000;
                    width: .3rem;
                }
            }
            .number{
                top: auto;
                left: 50%;
                bottom: .4rem;
                display: flex;
                transform: translate(-50%, 0);
                .item{
                    width: .4rem;
                    height: .4rem;
                    margin: 0 .2rem;
                    background: #fff;
                    color: #b2b2b2;
                    &::after{
                        display: none;
                    }
                }
            }
            .page_container{
                height: 100%;
                .page{
                    height: 100%;
                    border-radius: 0;
                }
                .page1{
                    overflow-y: auto;
                    background: #f2f2f2;
                    .p1{
                        font-size: .36rem;
                    }
                    .p2{
                        font-size: .3rem;
                        margin-bottom: .4rem;
                    }
                    .p3{
                        font-size: .26rem;
                        margin-bottom: .3rem;
                    }
                    .years{
                        flex-direction: column;
                        padding: 0 .3rem;
                        .item{
                            margin-bottom: .2rem;
                            border-radius: .12rem;
                            background: #fff;
                            flex-direction: row;
                            align-items: center;
                            padding: .25rem;
                            text-align: left;
                            .cover{
                                margin-bottom: 0;
                                margin-right: .6rem;
                                border-width: .1rem;
                                width: 2rem;
                                height: 2rem;
                            }
                            .text1,
                            .text2{
                                font-size: .36rem;
                            }
                        }
                    }
                }
                .page2{
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 1.2rem;
                    .back{
                        font-size: .26rem;
                        left: .4rem;
                        top: .4rem;
                        &::before{
                            width: .15rem;
                            height: .3rem;
                            background-size: 100% 100%;
                        }
                    }
                    .top_video{
                        height: 4.22rem;
                        .text_wrap{
                            font-size: .56rem;
                            left: .4rem;
                            bottom: .2rem;
                        }
                    }
                    .title{
                        font-size: .36rem;
                        padding: .48rem 0;
                    }
                    .group{
                        flex: 1;
                        display: block;
                        padding: 0 .4rem;
                        height: auto;
                        .tit{
                            font-size: .34rem;
                            padding-left: .6rem;
                            margin-bottom: .2rem;
                        }
                        .item{
                            width: 100%;
                            font-size: .3rem;
                            padding-left: .6rem;
                            margin-bottom: .2rem;
                            .checkbox{
                                width: .22rem;
                                height: .22rem;
                                border-radius: .04rem;
                            }
                        }
                    }
                    .btn{
                        width: 3rem;
                        height: .54rem;
                        font-size: .24rem;
                        margin: .55rem auto .25rem;
                        &::after{
                            width: .1rem;
                            height: .2rem;
                            background-size: 100% 100%;
                        }
                        &.type2{
                            width: 3rem;
                        }
                    }
                    .all{
                        font-size: .24rem;
                    }
                    .checked_item_row{
                        flex: 1;
                        display: flex;
                        flex-wrap: wrap;
                        // justify-content: center;
                        align-content: flex-start;
                        // height: 5.6rem;
                        padding: 0 .35rem;
                        overflow: hidden;
                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;
                        &::after{
                            content: "";
                            width: 3.2rem;
                            margin: 0 .1rem;
                        }
                        .tit{
                            width: 100%;
                            font-size: .3rem;
                            font-weight: bold;
                            margin: .2rem 0 .1rem;
                            padding-left: .1rem;
                        }
                        .item{
                            width: 3.2rem;
                            height: 1.8rem;
                            margin: .1rem;
                            position: relative;
                            .cover{
                                width: 100%;
                                height: 100%;
                                border-radius: .08rem;
                                background-repeat: no-repeat;
                                background-size: cover;
                            }
                            .text{
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                position: absolute;
                                bottom: 0;
                                left: 0;
                                right: 0;
                                padding: .1rem .2rem;
                                font-weight: bold;
                                font-size: .24rem;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>